import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { RichTextViewer, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import styles from './ServiceDescriptionContent.module.scss';
export default function ServiceDescriptionContent(props) {
    const { description, includedServices, testId } = props;
    const { t: texts } = useLocaleKeys('components.serviceDescriptionContent');
    const includedServicesWithDescription = includedServices ? includedServices.filter((s)=>s.description) : [];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            description && /*#__PURE__*/ _jsx(RichTextViewer, {
                value: description,
                testId: testId + 'full-description'
            }),
            includedServicesWithDescription.length > 0 && /*#__PURE__*/ _jsxs("ul", {
                className: styles.includedServices,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        weight: "bold",
                        children: texts.includedServices()
                    }),
                    includedServicesWithDescription.map((param)=>{
                        let { name, description } = param;
                        return /*#__PURE__*/ _jsxs(Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    as: "li",
                                    className: styles.includedServiceTitle,
                                    weight: "bold",
                                    testId: testId + 'included-service-title',
                                    children: name
                                }),
                                /*#__PURE__*/ _jsx(RichTextViewer, {
                                    className: styles.includedServiceDescription,
                                    value: description,
                                    testId: testId + 'included-service-description'
                                })
                            ]
                        }, name);
                    })
                ]
            })
        ]
    });
}
